module.exports = __webpack_public_path__ + "assets/img/popup-close.87694250.png";